export const ROUTE_CONSTANTS = {
  LAYOUT: '/',
  LOGIN: '/login',
  LOGOUT:'/logout',
  PlANNERWINDOW: '/plannerwindow',
  SELLIN: '/sellin',
  SELLOUT: '/sellout',
  COLLECTIONPLAN: '/collectionplan',
  OPEXPLAN: '/opexplan',
  ANNUALCOLLECTIONPLAN: '/annualcollectionplan',
  // ANNUALCOLLECTIONPLAN1: '/annual-collectionplan',
  ANNUALSALES:'/annualsales',
  // ANNUALCOLLECTION: '/annualcollectionplan',
  ANNUALOPEX: '/annualopexplan',
}
